import type { ReactNode } from 'react';
import './GlobalShell.css';
import { Header } from './Header.js';

export type AuthState = 'loading' | 'signed-out' | 'signed-in';

interface GlobalShellProps {
  children: ReactNode;
  authState: AuthState;
  userEmail?: string;
}

export function GlobalShell({
  children,
  authState,
  userEmail,
}: GlobalShellProps): ReactNode {
  const currentPage: 'home' | 'search' | 'admin' =
    typeof window !== 'undefined'
      ? window.location.pathname === '/search'
        ? 'search'
        : window.location.pathname === '/admin'
          ? 'admin'
          : 'home'
      : 'home';

  return (
    <div className="global-shell">
      <Header
        authState={authState}
        userEmail={userEmail}
        currentPage={currentPage}
      />
      <main className="global-shell__main">{children}</main>
    </div>
  );
}
